import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFDict from "PDFLib/core/objects/PDFDict";
import CharCodes from "PDFLib/core/syntax/CharCodes";
import {IndirectObjectJsonItem} from "PDFLib/core/writers/JSONWriter/JSONItem/IndirectObjectJsonItem";
import {JSONFactory} from "PDFLib/core/writers/JSONWriter/JSONFactory";

export class DictionaryObjectItem extends JSONItemBase{
    GetType() {
        return 'DI'
    }

    public Dict:{Key:string,Value:JSONItemBase}[];
    constructor(dict:PDFDict) {
        super();
        this.Dict=[];

        const entries =dict.entries();
        for (let idx = 0, len = entries.length; idx < len; idx++) {
            const [key, value] = entries[idx];
            this.Dict.push({
                Key:key.toString(),
                Value:JSONFactory.GetItem(value)
            })
        }
    }


}